const getSiteDomain = () => (
  process.env.NODE_ENV === "production"
    ? process.env.REACT_APP_DOMAIN_NAME
    : "localhost:50021"
)

export default getSiteDomain